// extracted by mini-css-extract-plugin
export var authorsWrapper = "marathon-module--authors-wrapper--5XTBS";
export var description = "marathon-module--description--88i65";
export var directionsWrapper = "marathon-module--directions-wrapper--4PqNS";
export var languageWrapper = "marathon-module--language-wrapper--ttllk";
export var postMainTitle = "marathon-module--post-main-title--I4WcP";